import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty016 - REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList (mask qlty016 / add qlty017 unchanged) */
export default function ErrorTypeList() {
  return <OtkOptionCatalogList resource="error_types" />;
}
